import React from "react";
import { NextPageContext } from "next";

import ErrorComponent from "../../src/components/Error";

const Error = ({ statusCode }: { statusCode: number }) => <ErrorComponent statusCode={statusCode} />;

Error.getInitialProps = ({ res, err }: NextPageContext) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : null;
  return { statusCode };
};

export default Error;
